export interface TemplateVariables {
  name?: string;
  primaryGoal?: string;
  challenge?: string;
  environment?: string;
  desiredFeeling?: string;
}

export const processPersonalizedTemplate = (
  template: string,
  variables: TemplateVariables
): string => {
  let processed = template;
  
  // Replace placeholders with user data or fallbacks
  processed = processed.replace(/{name}/g, variables.name || 'friend');
  processed = processed.replace(/{primaryGoal}/g, variables.primaryGoal || 'find peace and balance');
  processed = processed.replace(/{challenge}/g, variables.challenge || 'daily stress');
  processed = processed.replace(/{environment}/g, variables.environment || 'a comfortable space');
  processed = processed.replace(/{desiredFeeling}/g, variables.desiredFeeling || 'calm and centered');
  
  return processed;
};

export const extractUserVariables = (biography?: string): TemplateVariables => {
  // Extract basic info from biography if available
  const variables: TemplateVariables = {};
  
  if (biography) {
    // Simple extraction logic - could be enhanced with NLP
    const lines = biography.toLowerCase().split('\n');
    
    // Look for common patterns
    for (const line of lines) {
      if (line.includes('name') && line.includes('is')) {
        const nameMatch = line.match(/name is (\w+)/);
        if (nameMatch) variables.name = nameMatch[1];
      }
      
      if (line.includes('goal') || line.includes('want to')) {
        if (line.includes('stress') || line.includes('calm')) {
          variables.primaryGoal = 'reduce stress and find calm';
        } else if (line.includes('sleep') || line.includes('rest')) {
          variables.primaryGoal = 'improve sleep and rest';
        } else if (line.includes('confidence') || line.includes('motivation')) {
          variables.primaryGoal = 'build confidence and motivation';
        }
      }
      
      if (line.includes('challenge') || line.includes('struggle') || line.includes('difficult')) {
        if (line.includes('work') || line.includes('job')) {
          variables.challenge = 'work-related stress';
        } else if (line.includes('anxiety') || line.includes('worry')) {
          variables.challenge = 'anxiety and worry';
        } else if (line.includes('sleep') || line.includes('insomnia')) {
          variables.challenge = 'sleep difficulties';
        }
      }
    }
  }
  
  return variables;
};

export const generateTemplatePrompt = (
  template: string,
  variables: TemplateVariables,
  categoryName: string
): string => {
  const processedTemplate = processPersonalizedTemplate(template, variables);
  
  return `Create a personalized ${categoryName.toLowerCase()} session based on this template. 
  
Use this as the foundation and expand it into a complete 6-8 minute guided session (1,200-1,600 words):

${processedTemplate}

Maintain the personal elements and expand with appropriate techniques, breathing exercises, and therapeutic guidance. Keep the tone consistent with the template and ensure smooth transitions between sections.`;
};